<app-sticky-navbar *ngIf="section" [height]="stickyNavbarHeight">
    <app-premium-collection-sticky-navbar
        [collectionSlug]="premiumCollectionSlug"
        [collectionTitle]="premiumCollectionTitle"
        [colors]="section?.colors"
        [isStudent]="isStudent"
        [logo]="premiumCollectionLogo"
        [topics]="section?.topics"
    >
    </app-premium-collection-sticky-navbar>
</app-sticky-navbar>
<app-search-bar
    *ngIf="section"
    [collectionSlug]="premiumCollectionSlug"
    [collectionTitle]="premiumCollectionTitle"
    [colors]="section.colors"
    [logo]="premiumCollectionLogo"
>
</app-search-bar>
<app-element-placeholder *ngIf="!section" class="loading-placeholder"></app-element-placeholder>
<ng-container *ngIf="section">
    <div class="heading-wrapper">
        <app-heading
            [collection]="section"
            [colorLogo]="section.colorLogo"
            [hero]="section.hero"
            [resourcesDescription]="section.getResourceTypesDisplay()"
            [whiteLogo]="section.whiteLogo"
            jumpToSectionTitle="Jump to Resources by Topic"
        ></app-heading>
    </div>
    <section
        *ngFor="let topic of section.topics; let i = index"
        [triggerId]="topic.titleForAutoscroll"
        appStickyNavbarTrigger
        class="section {{ 'by-' + buildCssSelector(topic.title) }} selenium-topic-{{
            topic.titleForAutoscroll
        }}"
        id="section-{{ topic.titleForAutoscroll }}"
    >
        <div class="container">
            <div class="head-info">
                <div class="section-title">{{ topic.title }}</div>
                <div class="section-info">
                    {{ topic.getResourceTypesDisplay() }}
                </div>
                <div class="w-100 fw-bold mt-7 mb-3" *ngIf="!topic.resourceCount && isStudent">
                    No resources available for Grades {{ selectedGrade }}. Filter by All Grades to
                    see the full collection.
                </div>
            </div>
            <div *ngIf="innerWidth > cardTypeChangeBreakpoint" class="row">
                <div
                    *ngFor="let resource of topic.visibleLearningObjects"
                    class="col-auto card-container browse-card"
                >
                    <app-resource-browse-card [learningObject]="resource">
                    </app-resource-browse-card>
                </div>
            </div>
            <div
                *ngIf="innerWidth <= cardTypeChangeBreakpoint"
                class="row-auto resources-row-mobile"
            >
                <div
                    *ngFor="let resource of topic.visibleLearningObjects"
                    class="resource-card-mobile-wrapper"
                >
                    <app-ymal-card [learningObject]="resource"></app-ymal-card>
                </div>
            </div>
            <a
                (click)="showMore($event, topic)"
                *ngIf="topic.shouldShowLoadMore()"
                [attr.data-gtmlabel]="topic.title"
                [ngStyle]="{ 'background-color': section.colors.mainColor }"
                class="show-more gtm-premium-collection-show-more selenium-premium-collection-show-more"
                href="#"
                >+ Show
                {{
                    topic.resourceCount < 104
                        ? topic.resourceCount - topic.visibleLearningObjects.length
                        : 100
                }}
                more Resources
            </a>
            <a
                (click)="showLess($event, topic)"
                *ngIf="topic.shouldShowLoadLess()"
                [ngStyle]="{ 'background-color': section.colors.mainColor }"
                class="show-more"
                href="#"
            >
                - Show fewer Resources
            </a>
        </div>
    </section>
    <section *ngFor="let relatedSection of section.relatedSections" class="section">
        <div class="container">
            <div class="section-title">{{ relatedSection.title }}</div>
            <div *ngIf="relatedSection.cardType === 'mezzanine'" class="row-auto section-cards">
                <app-mezzanine-collection-card
                    *ngFor="let sectionItem of relatedSection.visibleItems"
                    [item]="sectionItem"
                    [sectionName]="relatedSection.pluralLabel"
                    class="col-6 col-md-4 col-lg-3 px-4"
                >
                </app-mezzanine-collection-card>
            </div>
            <div *ngIf="relatedSection.cardType === 'overlay'" class="row-auto section-cards">
                <app-overlay-collection-card
                    *ngFor="let sectionItem of relatedSection.visibleItems"
                    [item]="sectionItem"
                    [sectionName]="relatedSection.pluralLabel"
                    class="col-6 col-lg-4 px-4"
                >
                </app-overlay-collection-card>
            </div>
            <a
                (click)="showMoreRelated($event, relatedSection)"
                *ngIf="relatedSection.shouldShowLoadMore()"
                [attr.data-gtmlabel]="relatedSection.title"
                [ngStyle]="{ 'background-color': section.colors.mainColor }"
                class="show-more gtm-premium-collection-show-more-related selenium-premium-collection-show-more-related"
                href="#"
            >
                + Show more {{ relatedSection.pluralLabel }}
            </a>
            <a
                (click)="showLessRelated($event, relatedSection)"
                *ngIf="relatedSection.shouldShowLoadLess()"
                [ngStyle]="{ 'background-color': section.colors.mainColor }"
                class="show-more"
                href="#"
            >
                - Show fewer {{ relatedSection.pluralLabel }}
            </a>
        </div>
    </section>
    <app-premium-footer-links [colors]="section.colors" [footerSection]="section.footerSection">
    </app-premium-footer-links>
    <app-premium-footer-attributions
        [attributions]="footerAttributions"
        [credits]="section.credits"
    >
    </app-premium-footer-attributions>
</ng-container>
<app-available-features></app-available-features>
